import { render } from "./KeywordWrapperView.vue?vue&type=template&id=c164d35c&ts=true"
import script from "./KeywordWrapperView.vue?vue&type=script&lang=ts"
export * from "./KeywordWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__